/* eslint-disable */ 
import { URL } from '../../../config'
import { getRequest } from '../../../utils/functions/httpRequest'

export const getTeamStandingsBySeason = function (seasonId,eventId) 
{
    const endpoint = `/${seasonId}/${eventId}/teamstandings`
    const rankingURL = `${URL.ranking}${endpoint}` 
    return getRequest(rankingURL)
}


// WEBPACK FOOTER //
// ./src/components/pages/api/getTeamStandingsBySeason.js